import React from 'react';
import {Outlet, useLocation} from 'react-router-dom';
import {DocumentViewerProvider, useDocumentViewer} from '../../context/DocumentViewerContext';

import SideBarLeft from './SideBarLeft';
import SideBarRight from './SideBarRight';
import UserLayout from './UserLayout';
import UserLayoutFrame from './UserLayoutFrame';
import DocumentViewer from '../document-viewer/DocumentViewer';

export default function UserAppLayout() {
    const { pathname } = useLocation();

    // /chat 경로일 때는 DocumentViewerProvider 사용
    if (pathname.startsWith('/chat')) {
        return (
            <DocumentViewerProvider>
                <ChatLayout />
            </DocumentViewerProvider>
        );
    }

    return (
        <UserLayoutFrame
            leftSideBar={null}
            middleSideBar={null}
            rightSideBar={null}
        >
            <Outlet />
        </UserLayoutFrame>
    );
}

// Chat 전용 레이아웃
function ChatLayout() {
    const { isOpenRightSideBar } = useDocumentViewer();
    
    return (
        <UserLayoutFrame
            leftSideBar={null}
            middleSideBar={<UserLayout />}
            rightSideBar={
                isOpenRightSideBar 
                    ? <SideBarRight content={<DocumentViewer />} />
                    : null
            }
        >
            <Outlet />
        </UserLayoutFrame>
    );
}
